'use client';
import { clsx } from 'clsx';
import { type ApiImageProps } from 'components/UI/Image';
import { Pills } from 'components/UI/Pills';
import { useNoNav } from 'hooks/useNoNav';
import type { WidgetMenuProps } from 'types/menu';
import { normalizeBaseUrl } from 'utils/image';
import styles from './bannerNavigation.module.scss';

export interface WidgetMenuBannerNavigationProps extends WidgetMenuProps {
  readonly items?: ReadonlyArray<{
    readonly type: string;
    readonly model: {
      readonly image: ApiImageProps;
      readonly title: string;
    };
  }>;
}

export const WidgetMenuBannerNavigation = ({ context }: { context: WidgetMenuBannerNavigationProps }) => {
  const noNav = useNoNav();
  if (noNav) return null;

  let mobileImage, desktopImage;

  if (context.items) {
    mobileImage = context?.items?.length >= 1 && context.items[0].type === 'picture' ? context.items[0] : undefined;
    desktopImage = context?.items?.length >= 2 && context.items[1].type === 'picture' ? context.items[1] : undefined;
  }

  return (
    <div className={styles.menu}>
      {(mobileImage || desktopImage) && (
        <div className={styles.imageWrapper}>
          <picture>
            {mobileImage && (
              <source
                media="(max-width: 743px)"
                srcSet={`${normalizeBaseUrl(mobileImage.model.image.baseUrl)}mobileBanner.webp`}
              />
            )}
            {desktopImage && (
              <source
                media="(min-width: 744px)"
                srcSet={`${normalizeBaseUrl(desktopImage.model.image.baseUrl)}desktopBanner.webp`}
              />
            )}
            { }
            <img
              className={clsx(styles.image)}
              src={`${normalizeBaseUrl((desktopImage ?? mobileImage)!.model.image.baseUrl)}${
                desktopImage ? 'desktopBanner.webp' : 'mobileBanner.webp'
              }`}
              alt={(desktopImage ?? mobileImage)!.model.title}
            />
          </picture>
        </div>
      )}
      <nav className={styles.navigation}>
        <Pills className="banner-navi-pill" items={context.model.menu} />
      </nav>
    </div>
  );
};
